import { BottomNavigation, BottomNavigationAction, Box, Container, Paper, Stack } from "@mui/material";
import { LogementPageOutletContext, ViewKind } from "../LogementPageBase";
// import { OutputFile } from "../../../components/OutputFile";
import { useNavigate, useOutletContext } from "react-router";
// import { OutputMedias } from "../../../components/OutputMedias";
import { OutputMedias } from "../../../components/OutputMedias";
import { NavigateBefore, NavigateNext } from "@mui/icons-material";

export interface DocumentsTabContentProps {
    readonly viewKind: ViewKind;
}

export const DocumentsTabContent = (props: DocumentsTabContentProps) => {
  const { logementAccessor } = useOutletContext() as LogementPageOutletContext;
  const programme = logementAccessor.nomProgramme;
  const numLogement = logementAccessor.numLogement;
  // const ficheAccessor = logementAccessor.fiche;
  const mediasAccessor = logementAccessor.medias;
  const navigate = useNavigate();
  const goToPrevious = () => {
      navigate("../comments");
  };
  const goToNext = () => {
    navigate(`../${props.viewKind === ViewKind.Read ? "historique" : "save"}`);
  };
  return (<Box sx={{ pb: 7 }}>
    <Stack spacing={1}>
    {/* <OutputFile
      readonly={props.viewKind === ViewKind.Read}
      title="Fiche de relevé"
      fileName={`Fiche de relevé ${programme?.get()} ${numLogement?.get()}`}
      valueAccessor={ficheAccessor}
      apiService={props.apiService}
    /> */}
      <OutputMedias
        readonly={props.viewKind === ViewKind.Read}
        title="Photos, plans, etc (ATTENTION : ces documents pourront être accessibles au public)"
        fileName={`logement ${programme?.get()} ${numLogement?.get()}`}
        valueAccessor={mediasAccessor}
      />
    </Stack>
    <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1000 }} elevation={3}>
      <Container sx={{p: "1 1"}} maxWidth="md">
        <BottomNavigation
          showLabels
        >
          <BottomNavigationAction label="Précédent" icon={<NavigateBefore />} onClick={goToPrevious} />
          <BottomNavigationAction label="Suivant" icon={<NavigateNext />} onClick={goToNext} />
        </BottomNavigation>
      </Container>
    </Paper>
  </Box>);
};
